import { render, staticRenderFns } from "./SortableTables.vue?vue&type=template&id=3c11a31c"
import script from "./SortableTables.vue?vue&type=script&lang=js"
export * from "./SortableTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports